import { render, staticRenderFns } from "./AppointmentTable.vue?vue&type=template&id=538ba012&scoped=true&"
import script from "./AppointmentTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentTable.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTable.vue?vue&type=style&index=0&id=538ba012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ba012",
  null
  
)

export default component.exports